import type { FC } from 'react'

import { Input } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'

export const SddTripletex: FC = () => (
  <div className="mt-3">
    <Field name="salaryDeductionCodeUsage">
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          capitalizeLabel
          id="salaryDeductionCodeUsage"
          label={
            <>
              <Translation id="Accounting code device" />*
            </>
          }
          marginBottom={16}
          touched={meta.touched}
          error={meta.error}
          {...field}
        />
      )}
    </Field>
  </div>
)
